import React from 'react';

/**
 * THE DOOR.
 *
 * A full-width ink band at the foot of each half of the client page, leading
 * to the other half. Tom's idea, and the best one to come out of the
 * conversation that designed this page.
 *
 * **The summary line is the point.** *1 of 25 done · 10 waiting on you · next
 * up: main interview shoot, 26–30 October* tells a client who never clicks it
 * everything they came for. A door labelled only "The plan" is furniture; a
 * door that says what is behind it is a second page they do not have to open.
 *
 * One per page, at the very bottom, and never more than one — a page with two
 * ways out is a menu, and this page has no menus.
 */
export function PageDoor({
  title,
  summary,
  stage,
  onOpen
}: {
  /** Where it goes: "The plan", "Your films". */
  title: string;
  /** What is behind it, right now. Drawn only when there is something to say. */
  summary: string;
  /** Which stage the job is in, or ''. */
  stage?: string;
  onOpen: () => void;
}) {
  return <button type="button" onClick={onOpen} className="group mt-24 block w-full bg-ink px-8 py-12 text-left text-paper transition-opacity duration-200 ease-out hover:opacity-90 sm:mt-32 sm:px-12 sm:py-16" data-id="element-127" data-mp="3pe7k6exi9hhl">
      {/* The stage name alone read as the company's own name in the first
          screenshot of this door — PRODUCTION, in caps, under Portal
          Productions. "Now" in front of it fixes that and earns its line. */}
      <span className="label block text-paper/55" data-id="element-128" data-mp="c1xjti30cdt9">
        {stage ? `Now · ${stage}` : 'Also on this page'}
      </span>

      <span className="mt-5 flex items-baseline justify-between gap-8" data-id="element-129" data-mp="ly0hobqttqae">
        <span className="font-display text-[2.1rem] font-light leading-none tracking-tight sm:text-[3rem]" data-id="element-130" data-mp="lx8wluuuvayd">
          {title}
        </span>
        <span aria-hidden="true" className="shrink-0 text-[1.6rem] leading-none transition-transform duration-200 ease-out group-hover:translate-x-1 sm:text-[2rem]" data-id="element-131" data-mp="2novhdeo5m9me">
          &rarr;
        </span>
      </span>

      {summary && <span className="mt-6 block max-w-[46ch] text-[1.05rem] font-light leading-relaxed text-paper/75" data-id="element-132" data-mp="38gixlrtqejv8">
          {summary}
        </span>}
    </button>;
}